import React from 'react';
import { useNavigate } from "react-router-dom";
import { Tabs, Card } from 'antd';
import { WebsiteIndexEntry } from '../../../deepAnalysis/websiteIndexEntry/types';
import CompetitorsTab from './CompetitorsTab';
import KeywordsTab from './KeywordsTab';
import LocationTab from './LocationTab';
import RemoveUrlTab from './RemoveUrlTab';
import NotificationsTab from './NotificationsTab';

const { TabPane } = Tabs;

type Props = {
    selectedWebsite: WebsiteIndexEntry | undefined;
    section?: string;
};

export default function DashboardSettingsTabs({ selectedWebsite, section }: Props) {
    const navigate = useNavigate();

    const handleTabChange = (newSelectedOption: string) => {
        navigate(`/dashboard/settings/${newSelectedOption}?w_guid=${selectedWebsite?.guid}`);
    };

    return (
        <Card className="dashboard-settings-tabs">
            {selectedWebsite && (
                <Tabs
                    animated={false}
                    destroyInactiveTabPane={true}
                    activeKey={section}
                    onChange={handleTabChange}
                >
                    <TabPane tab="Competitors" key="competitors">
                        <CompetitorsTab selectedWebsite={selectedWebsite} />
                    </TabPane>

                    <TabPane tab="Keywords" key="keywords">
                        <KeywordsTab selectedWebsite={selectedWebsite} />
                    </TabPane>

                    <TabPane tab="Monitor Locations" key="monitor-locations">
                        <LocationTab selectedWebsite={selectedWebsite} />
                    </TabPane>

                    <TabPane tab="Notifications" key="notifications">
                        <NotificationsTab selectedWebsite={selectedWebsite} />
                    </TabPane>

                    <TabPane tab="Remove Website" key="remove-url">
                        <RemoveUrlTab selectedWebsite={selectedWebsite} />
                    </TabPane>
                </Tabs>
            )}
        </Card>
    );
}
